import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

export function ScrapersMassImport(){

    let [text, setText] = useState("");
    let [jsonValid, setJsonValid] = useState(false);
    let [queue, setQueue] = useState([] as any[]);
    let [importRunning, setImportRunning] = useState(false);
    let [importStatus, setImportStatus] = useState("Not started yet");

    function handleTextChanged(event){
        setText(event.target.value);
    }

    function handleImportClicked(){
        setImportRunning(true);
        let jsonParsed = JSON.parse(text);
        const scrapers = [];
        for(const currentItem of jsonParsed){
            if(!currentItem["Page Title"]){
                alert("Missing page title");
                continue;
            }
            if(!currentItem.URL){
                alert("Missing URL");
                continue;
            }

            const name = currentItem["Page Title"];
            const url = currentItem.URL;

            scrapers.push({name: name, url: url, regex: "", interval: 6 * 60 * 60 * 1000});
            setQueue(scrapers as any[]);
        }
    }

    useEffect(() => {
        try{
            JSON.parse(text);
            setJsonValid(true);
        }
        catch(e){
            setJsonValid(false);
        }
    }, [text]);

    useEffect(() => {
        if(queue.length == 0){
            setImportRunning(false);
        }
        else{
            const scraper = queue.shift();
            setImportStatus("Creating " + scraper.name);
            StorylineServerProxy.createScraper(scraper).then(() => { 
                console.log("Done, new queue size " + queue.length); 
                const newQueue = [... queue];
                setQueue(newQueue);
            });
        }
    }, [queue]);

    return (
        <>
            Hello mass importer!
            <br/>
            <TextField multiline rows={10} sx={{width: 10/10 }} value={text} onChange={handleTextChanged}/>            
            <br/>
           {
                jsonValid?importRunning?<CircularProgress/>:<><Button onClick={handleImportClicked} >Import</Button></>:<>Invalid JSON</>
           }
           <br/>
           <br/>
           <Typography>{ importStatus }</Typography>
        </>
    )
}